// extracted by mini-css-extract-plugin
export default {"payment":"Success_payment__1iGpW","item":"Success_item__JEKIg"};